import { render, staticRenderFns } from "./depositPaymentList.vue?vue&type=template&id=01b832ed"
import script from "./depositPaymentList.vue?vue&type=script&lang=js"
export * from "./depositPaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports